import { DocumentService } from "./DocumentService";

export class SettlementVendorOpeningBalancesService extends DocumentService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        return clonedObject;
    }

}